function getSearchParameters() {
    var prmstr = window.location.search.substr(1);
    return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
}

function headerHeight() {
    var headerHeight = $('#top').outerHeight();
    $('.banner').css('margin-top', headerHeight);
}

function transformToAssocArray( prmstr ) {
    var params = {};
    var prmarr = prmstr.split("&");
    for ( var i = 0; i < prmarr.length; i++) {
        var tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

var params = getSearchParameters();

$(window).resize(adjustLayout);

function adjustLayout(){
    $('.slick-dots').css({'margin-left': -($('.slick-dots').width()/2)});
    $('.banner-overlay-inner').css({'margin-top': -($('.banner-overlay-inner').height()/2)});
}

var groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

$(function(){
    headerHeight();
    $('.banner').css('margin-top', headerHeight);

    $(function() {
        $('.match-height').matchHeight();
    });


    $(function() {
        $(".meter > span").each(function() {
            $(this)
                .data("origWidth", $(this).width())
                .width(0)
                .animate({
                    width: $(this).data("origWidth")
                }, 1200);
        });
    });

    $(document).scroll(function () {
      var positieY = $(document).scrollTop(),
          header = $("#header").height(),
          headertotal = (header-64);

      if (positieY > (headertotal)) {
          $("#top").addClass('sticky');
      }
      if (positieY < (headertotal)) {
          $("#top").removeClass('sticky');
      }
    });

    $( window ).resize(function() {
        $('.match-height').matchHeight();
    });

    $(".disable-scroll").click(function(){
        $('.disable-scroll').fadeOut();
    });


    $('.fancybox').fancybox({
        beforeLoad: function(data){
            $('.debugmsgs').remove();
        }
    });

    $('.content-fancybox-gallery .fancybox').each(function(){
        $(this).attr('data-fancybox-group','data-fancybox-group');
    });

    $('.fancybox-ajax').fancybox({
        type        : 'ajax',
        beforeLoad  : function(data){
            $('.debugmsgs').remove();
        },
        afterShow   : function (){
            JSInit();
        }
    });

    $('.ajax').click(function() {
        $.get($(this).attr('href'), { action: 'Form', actionHref: $(this).attr('href') }, function(html) {
            $.fancybox(html, {
                'width': 600,
                'autoSize' : false
            });
        });
        return false;
    });

    $('.fancybox-iframe2').fancybox({
        'type' : 'iframe',
        'titleShow' : false,
        'transitionIn' : 'elastic',
        'transitionOut' : 'elastic',
        'padding' : 0,
        'maxWidth' : 800,
        'maxHeight' : 450,
        'fitToView' : true,
        'autoScale' : true
    });


    $(".form-mod-opmerking").click(function(){
        $(this).find(".form-mod-opmerking-balloon").toggleClass("form-mod-opmerking-balloon-show");
    });

    $(".form-mod-opmerking-balloon").mouseout(function(){
        $(".form-mod-opmerking-balloon").removeClass("form-mod-opmerking-balloon-show");
    });

    $(this).mouseout(function(){
        $(this).find(".form-mod-opmerking-balloon").removeClass("form-mod-opmerking-balloon-show");
    });


    $.repairLink2Anchor();

    if($.timepicker)
    {
        $.timepicker.regional['nl'] = {
            currentText: 'Nu',
            closeText: 'Sluiten',
            ampm: false,
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            timeFormat: 'hh:mm',
            timeSuffix: '',
            timeOnlyTitle: 'Kies een tijd',
            timeText: 'Tijd',
            hourText: 'Uur',
            minuteText: 'Minuut',
            secondText: 'Seconde',
            millisecText: 'Milliseconde',
            timezoneText: 'Tijdszone'};
        $.timepicker.setDefaults($.timepicker.regional['nl']);
        $(".datetime").datetimepicker();
        $(".time").timepicker({});
    }
    if($.datepicker)
    {
        $.datepicker.regional['nl'] = {
            closeText: 'Sluiten',
            prevText: 'Vorige maand',
            nextText: 'Volgende maand',
            currentText: 'Vandaag',
            monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
            monthNamesShort: ['jan', 'feb', 'maa', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
            dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
            dayNamesShort: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
            dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
            weekHeader: 'Wk',
            dateFormat: 'd MM yy',
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: '',
            changeMonth: true,
            changeYear: true,
            yearRange: "-100:+100"};
        $.datepicker.setDefaults($.datepicker.regional['nl']);
        $(".date").datepicker();
    }


    $('.tooltip').each(function(){
        var content = '';
        if (typeof($(this).data('tooltip')) !== "undefined" && $(this).data('tooltip').length > 0)
        {
            content = $(this).data('tooltip');
        }
        else if (typeof($(this).attr('title')) !== "undefined" && $(this).attr('title').length > 0)
        {
            content = $(this).data('tooltip');
        }
        $(this).tooltipster({
            content: content
        });
    });

    initVariableSlider('variable-width', 3, 0);
    initVariableSlider('testimonial-slider', 4, 40);

    var interval = setInterval(function() {
        $('.testimonial-slider a img').each(function() {
           var imageHeight = $(this).height(),
               aHeight = $(this).parent().height(),
               margin = (aHeight - imageHeight) / 2;

            $(this).css('margin-top', margin);
        });
    }, 200);

    setTimeout(function() {
        clearInterval(interval);
    }, 1000);
});

function initVariableSlider(className, slidesToShow, centerPadding) {
    var $variable_width = $('.' + className);
    if($variable_width.length > 0) {
        $variable_width.slick({
            slidesToShow: slidesToShow,
            centerPadding: centerPadding,
            infinite: true,
            arrows: false,
            dots:true,
            autoplay:true,
            centerMode:false,
            adaptiveHeight: true,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        slidesToShow: 3,
                        centerPadding: centerPadding,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        centerPadding: 0,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $variable_width.find('.slick-dots').wrap('<div class="container" style="position: relative;">');
    // .css({
    //         left: ($('.container').offset().left + ($('.slick-dots').width() / 2)) + 'px'
    //     });

        $('.slick-next').click(function () {
            $variable_width.slick('slickNext');
        });
        $('.slick-prev').click(function () {
            $variable_width.slick('slickPrev');
        });
        adjustLayout();
    }
}

// bugfix for internet explorer zodat onchange getriggered kan worden
if ($.browser.msie) {
    $(function() {
        $('input:radio, input:checkbox').click(function() {
            this.blur();
            this.focus();
        });
    });
}


function replaceContent(content)
{
    $('#container-content').empty().append(content);
}

/**
* Fancybox message
* @param {bit} success
* @param {string} title
* @param {string} content
* @param {string} extraHtml
*/
function showFancyboxMessage(success, title, content, extraHtml)
{
    if (typeof(extraHtml) === "undefined")
    {
        extraHtml = '';
    }
    var fancyboxContent = '<div id="fancybox-wrapper">';
    fancyboxContent += '<h1 class="fancybox-title-' + (success ? 'success' : 'error') +'">' + title + '</h1>';
    fancyboxContent += '<p>' + content + '</p>';
    fancyboxContent += extraHtml;
    fancyboxContent += '</div>';
    $.fancybox(fancyboxContent);

}

function bannerresize() {
    var sidebar_width = $('#width-container .sidebar__left').outerWidth();
    var content_left = $('#width-container .flex-container .left').outerWidth();
    $('.banner .sidebar__left').css('maxWidth',(sidebar_width + 1));
    $('#content-home-intro .sidebar__left').css('width',($('.banner .sidebar__left').outerWidth()));
    $('#content-home-intro .sidebar__left').css('maxWidth',($('.banner .sidebar__left').outerWidth()));
    $('.banner__slider__left').css( { maxWidth: (content_left - 1) } );
    $('.header .sidebar__left').css( { maxWidth: ($('.banner .sidebar__left').outerWidth()) } )
    $('#content-home-intro .content-home-intro-left').css( { maxWidth: ($('.banner .banner__slider__left').outerWidth()) } )
    $('#content-home-intro .content-home-intro-left').css( { maxWidth: ($('.banner .banner__slider__left').outerWidth()) } )
    if($('.projectpagina-banner-titel-layer').length) {
        $('.new-design_container').addClass('project-pagina')
        $('#layer-categories-home .category-text').css('paddingLeft',(sidebar_width + 1));
    }
}

function projectTextPosition() {
    if($('.projectpagina-container').length) {
        var eLeft = $('.projectpagina-container').offset().left - $('.new-design_container #content').offset().left;
        $('#layer-categories-home .category-text').css('paddingLeft', eLeft);
        if($(window).width()<1000) {
            $('#layer-categories-home .category-text').css('paddingRight', eLeft);
        }
    }
}
